import React, { Suspense, lazy } from "react";
import { Helmet } from "react-helmet-async";
import Preloader from "../Global/Preloader";
import Header from "../Global/Header";
import BredCrumb from "../Global/BredCrumb";
import LazySection from "../Global/LazySection";
import ErrorBoundary from "../Global/ErrorBoundary";

// Lazy load components
const Footer = lazy(() => import("../Global/Footer"));
const GoToTop = lazy(() => import("../Global/GoToTop"));
const ModelWoven = lazy(() => import("./ModelWoven"));
const ContohWoven = lazy(() => import("./ContohWoven"));

const Main = () => {
  return (
    <>
      <Helmet>
        <title>Label Woven Custom | Logo Woven Mina</title>
        <meta name="description" content="Label woven custom berkualitas tinggi untuk branding garment Anda. Tersedia berbagai desain dan ukuran. Pesan sekarang di Logo Woven Mina." />
        <link rel="canonical" href="https://www.logowovenmina.com/label-woven" />
      </Helmet>
      <Preloader />
      <Header />
      <BredCrumb Title="Label Woven" subtitle="Label Woven" />
      <div className="page_wrapper">
        <LazySection minHeight="600px">
          <ErrorBoundary
            title="Model 3D tidak dapat dimuat"
            message="Perangkat Anda mungkin tidak mendukung tampilan 3D. Silakan lanjutkan scrolling untuk melihat konten lainnya."
          >
            <Suspense fallback={null}>
              <ModelWoven />
            </Suspense>
          </ErrorBoundary>
        </LazySection>

        <LazySection>
          <Suspense fallback={null}>
            <ContohWoven />
          </Suspense>
        </LazySection>

        <LazySection>
          <Suspense fallback={null}>
            <Footer />
          </Suspense>
        </LazySection>

        <Suspense fallback={null}>
          <GoToTop />
        </Suspense>
      </div>
    </>
  );
};
export default Main;
